// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2861I","label":"LabeledBox_label__cHYLS"};